<template>
  <div>


<h2 class="goth">Prepositioner som styr ackusativ</h2>


<div class="grammatikparagrafbredd leftorient">


<p>Efter följande prepositioner står substantivet eller pronomenet alltid i ackusativ</p>

<table class="">


    <tr class="leftorient">
        <td class="vit bggron"><b>durch</b></td>
        <td class="vit bggron">genom</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bggron"><b>für</b></td>
        <td class="vit bggron">för</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bggron"><b>gegen</b></td>
        <td class="vit bggron">mot</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bggron"><b>ohne</b></td>
        <td class="vit bggron">utan</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bggron"><b>um</b></td>
        <td class="vit bggron">runt, omkring, om</td>
    </tr>


</table>


<br>
<div class="ruta">

<p><i>Helmut fährt <b>durch den</b> Wald.</i><br>
Helmut åker genom skogen.</p>
<p><i>Ich mache es <b>für dich</b>.</i><br>
Jag gör det för dig.</p>
<p><i>Kann man wirklich <b>gegen den</b> Wind segeln?</i><br>
Kan man verkligen segla mot vinden?</p>
<p><i><b>Ohne meinen</b> Computer kann ich diese Aufgabe nicht machen.</i><br>
Utan min dator kan jag inte göra denna uppgift.</p>
<p><i>Die kinder rennen <b>um den</b> Baum herum.</i><br>
Barnen springer runt trädet.</p>

</div>


<br><br>






</div>

<h4 class="grammatikparagrafbredd leftorient">Bestämd artikel i ackusativ</h4><br>


    <table class="">

        <tr class="leftorient">
            <td class="ljusvgra"></td>
            <td class="ljusgra">mask.</td>
            <td class="ljusgra">neutr.</td>
            <td class="ljusgra">fem.</td>
            <td class="ljusgra">plur.</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">nom.</td>
            <td class="vit bgbla">der</td>
            <td class="vit bgbla">das</td>
            <td class="vit bgbla">die</td>
            <td class="vit bgbla">die</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ack.</td>
            <td class="vit bggron"><b>den</b></td>
            <td class="vit bggron">das</td>
            <td class="vit bggron">die</td>
            <td class="vit bggron">die</td>
        </tr>

    </table>
    <br>
<p class="grammatikparagrafbredd leftorient">Ord som <i>dieser</i> böjs på liknande sätt (blir alltså <i><b>diesen</b></i> i ackusativ maskulinum).</p>
<br>


    <h4 class="grammatikparagrafbredd leftorient">Obestämd artikel i ackusativ</h4><br>


        <table class="">

            <tr class="leftorient">
                <td></td>
                <td class="ljusgra">mask.</td>
                <td class="ljusgra">neutr.</td>
                <td class="ljusgra">fem.</td>

            </tr>

            <tr class="leftorient">
                <td class="ljusgra">nom.</td>
                <td class="vit bgbla">ein</td>
                <td class="vit bgbla">ein</td>
                <td class="vit bgbla">eine</td>

            </tr>

            <tr class="leftorient">
                <td class="ljusgra">ack.</td>
                <td class="vit bggron"><b>einen</b></td>
                <td class="vit bggron">ein</td>
                <td class="vit bggron">eine</td>

            </tr>

        </table>
<br>
<p class="grammatikparagrafbredd leftorient">Ord som <i>mein, dein, kein, ihr</i> o.s.v. böjs på liknande sätt (blir alltså <i><b>meinen, deinen, keinen, ihren</b></i> o.s.v. i ackusativ maskulinum).</p>

<br>

<div class="quasi-p leftorient mindre">Som framgår av tabellerna ovan är det egentligen bara
    <b>maskulina artiklar i singular </b>som får en annan form i ackusativ.
</div>

<br><br>

<br>
<h4 class="grammatikparagrafbredd leftorient">Personliga pronomen i ackusativ</h4><br>
<table class="">

    <tr class="leftorient">
        <td class="ljusgra">svenska</td>
        <td class="ljusgra">nominativ</td>
        <td class="ljusgra">ackusativ</td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">jag / mig</td>
        <td class="vit bgbla">ich</td>
        <td class="vit bggron"><b>mich</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">du / dig</td>
        <td class="vit bgbla">du</td>
        <td class="vit bggron"><b>dich</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">han / honom<br>det / det<br>hon / henne</td>
        <td class="vit bgbla">er<br>es<br>sie</td>
        <td class="vit bggron"><b>ihn</b><br>es<br>sie</td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">vi / oss</td>
        <td class="vit bgbla">wir</td>
        <td class="vit bggron"><b>uns</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">ni / er</td>
        <td class="vit bgbla">ihr</td>
        <td class="vit bggron"><b>euch</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">de / dem<br>Ni / Er</td>
        <td class="vit bgbla">sie<br>Sie</td>
        <td class="vit bggron">sie<br>Sie</td>
    </tr>




</table>


<br>

<div class="quasi-p leftorient mindre">När ett ord står i ackusativ efter något av prepositionerna
    <i>durch, für, gegen, ohne, um</i> kallas satsdelen
<b><i>prepositionsobjekt i ackusativ</i></b> och skall inte förväxlas med <i>ackusativobjekt</i>.</div>

<br>
</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "prepositioner som styr ackusativ"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
